<template>
  <div :class="{ 'alert alert--danger': messages.length }">
    <ul v-if="messages.length > 1" class="alert--list">
      <li v-for="message in messages">
        <strong v-if="message.path">{{ message.path }}:</strong> {{ message.message }}
      </li>
    </ul>
    <template v-if="messages.length === 1">
      <strong v-if="messages[0].path">{{ messages[0].path }}:</strong> {{ messages[0].message }}
    </template>
  </div>
</template>
<script>
  export default {
    props: {
      messages: Array
    }
  }
</script>



// WEBPACK FOOTER //
// ErrorNotice.vue?40b735a2